import React, { useContext } from "react";
import { Form, Checkbox } from "antd";
import { getFormItemLabel, getFormItemVaidation } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import RestrictedContext from "../util/RestrictedContext";

const DaysSelectorComponent = ({ value, onChange, disabled }) => {
  const restricted = useContext(RestrictedContext);
  const options = [
    { value: 0, label: "א" },
    { value: 1, label: "ב" },
    { value: 2, label: "ג" },
    { value: 3, label: "ד" },
    { value: 4, label: "ה" },
    { value: 5, label: "ו" },
    { value: 6, label: "ש" },
  ];

  const handleCheckboxChange = (checkedValues) => {
    if (onChange) {
      onChange(checkedValues);
    }
  };

  return (
    <Checkbox.Group
      options={options}
      disabled={!restricted["hasWritePermission"] || disabled}
      value={value}
      onChange={handleCheckboxChange}
    />
  );
};

const DaysSelectorItems = (props) => {
  const { name, category, required, disabled, style } = props;
  const restricted = useContext(RestrictedContext);
  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);
  const arr = [];
  if (required) {
    arr.push("required");
  }
  const rules = getFormItemVaidation(intl, label, arr);

  return (
    <Form.Item name={name} rules={rules} label={label} style={style}>
      <DaysSelectorComponent
        disabled={!restricted["hasWritePermission"] || disabled}
      />
    </Form.Item>
  );
};

DaysSelectorItems.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
  required: PropTypes.bool,
};

export default DaysSelectorItems;
